
import React, { useState, useEffect, useRef } from "react";
import { navItems } from "../nav-items";
import NavbarTopSection from "./navbar/NavbarTopSection";
import NavbarDropdownItem from "./navbar/NavbarDropdownItem";
import MobileMenu from "./navbar/MobileMenu";
import { useLocation } from "react-router-dom"; // NEW

const Navbar = () => {
  const [openPopover, setOpenPopover] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdowns, setMobileDropdowns] = useState({});
  const [isHidden, setIsHidden] = useState(false);
  const lastScrollY = useRef(0);
  const navbarRef = useRef(null);
  const topSectionRef = useRef(null);
  const topSectionHeight = useRef(0);
  const animationInProgress = useRef(false);
  const scrollTimeout = useRef(null);
  const SCROLL_THRESHOLD = 100;
  const SCROLL_DELAY = 33;
  const location = useLocation(); // NEW

  useEffect(() => {
    if (topSectionRef.current) {
      topSectionHeight.current = topSectionRef.current.offsetHeight;
    }

    const handleScroll = () => {
      if (animationInProgress.current) return;
      
      const currentScrollY = window.scrollY;
      
      if (currentScrollY <= SCROLL_THRESHOLD) {
        if (scrollTimeout.current) {
          clearTimeout(scrollTimeout.current);
        }
        
        scrollTimeout.current = setTimeout(() => {
          if (isHidden) {
            animationInProgress.current = true;
            setIsHidden(false);
            setTimeout(() => {
              animationInProgress.current = false;
            }, 400);
          }
          lastScrollY.current = currentScrollY;
        }, SCROLL_DELAY);
        return;
      }

      if (currentScrollY > lastScrollY.current && !isHidden) {
        animationInProgress.current = true;
        setIsHidden(true);
        setTimeout(() => {
          animationInProgress.current = false;
        }, 400);
      } else if (currentScrollY < lastScrollY.current && isHidden) {
        animationInProgress.current = true;
        setIsHidden(false);
        setTimeout(() => {
          animationInProgress.current = false;
        }, 400);
      }
      
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, [isHidden]);

  const toggleMobileDropdown = (title) => {
    setMobileDropdowns(prev => ({ ...prev, [title]: !prev[title] }));
  };

  const currentPath = location.pathname + location.hash; // for hash section support

  return (
    <header 
      ref={navbarRef}
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        transform: `translateY(${isHidden ? '-100px' : '0'})`,
        transition: 'transform 0.4s ease'
      }}
    >
      <div ref={topSectionRef}>
        <NavbarTopSection 
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />
      </div>

      <div className="bg-orange-400 relative">
        <div className="container mx-auto py-2.5">
          <nav className="hidden md:block h-7">
            <ul className="flex justify-center space-x-8 items-stretch font-alatsi h-full">
              {navItems.map((item) => (
                <li key={item.title} className="flex items-stretch -my-2.5">
                  <NavbarDropdownItem
                    item={item}
                    openPopover={openPopover}
                    setOpenPopover={setOpenPopover}
                    currentPath={currentPath} // PASS CURRENT PATH
                  />
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <MobileMenu
        mobileMenuOpen={mobileMenuOpen}
        mobileDropdowns={mobileDropdowns}
        toggleMobileDropdown={toggleMobileDropdown}
        setMobileMenuOpen={setMobileMenuOpen}
        navItems={navItems}
      />
    </header>
  );
};

export default Navbar;

